import { z } from "zod";
import i18n from "@/i18n";

const t = (key: string) => i18n.t(`sso.${key}`);

export const createGoogleSsoSchema = () =>
  z.object({
    clientId: z
      .string()
      .trim()
      .min(1, { message: t("validation.clientIdRequired") }),
    clientSecret: z
      .string()
      .trim()
      .min(1, { message: t("validation.clientSecretRequired") }),
  });

export const createAppleSsoSchema = () =>
  z.object({
    clientId: z
      .string()
      .trim()
      .min(1, { message: t("validation.clientIdRequired") }),
    teamId: z
      .string()
      .trim()
      .min(1, { message: t("validation.teamIdRequired") }),
    keyId: z
      .string()
      .trim()
      .min(1, { message: t("validation.keyIdRequired") }),
    privateKey: z
      .string()
      .trim()
      .min(1, { message: t("validation.privateKeyRequired") }),
  });

export type GoogleSsoFormData = z.input<
  ReturnType<typeof createGoogleSsoSchema>
>;
export type AppleSsoFormData = z.input<ReturnType<typeof createAppleSsoSchema>>;
